(function () {

  'use strict';

  angular.module('eclipseApp.core').factory('accountDashboardManager', ['$rootScope', '$http', '$q', 'uteEndpoint', 'commonService', '$state', 'notifier', 'changeTechInstallService', 'uteLocale','util', function ($rootScope, $http, $q, uteEndpoint, commonService, $state, notifier, changeTechInstallService, uteLocale,util) {

    var accountDashboardManager = {
      checkoutSession: {
        review: {
          complete: false
        },
        confirmation: {
          complete: false
        }
      },
      currentInternetPackage: null,
      newInternetPackage: null,
      changeInternetPackageConfirmed: false,
      tierInDashboard: function () {
        return this.currentInternetPackage;
      },
      getSession: function (sessionName) {
        var _session;
        if (sessionName) {
          _session = sessionStorage.getItem(sessionName);
          return angular.fromJson(_session);
        }
      },
      setSession: function (sessionName, sessionObj) {
        var _session;
        if (sessionName && sessionObj) {
          _session = angular.toJson(sessionObj);
          sessionStorage.setItem(sessionName, _session);
          return this.getSession(sessionName);
        }
      },
      completeStep: function (stepName) {
        if (stepName && (stepName in this.checkoutSession)) {
          this.checkoutSession[stepName].complete = true;
          this.setSession('checkoutSession', this.checkoutSession);
          this.nextStep(this.checkoutSession);
        } else {
          console.log('@accountDashboardManager:completeStep: @params invalid or missing!');
        }
      },
      nextStep: function (session) {
        var base = 'myAccount.internet.package.change.',
          incompleteStep = _.findKey(this.checkoutSession, { complete: false });

        if (incompleteStep) {
          $state.go(base.concat(incompleteStep));
        }

      },
      reset: function () {
        this.currentInternetPackage = null;
        this.newInternetPackage = null;
        this.changeInternetPackageConfirmed = false;
      },
      resetConfirmation: function () {
        this.changeInternetPackageConfirmed = false;
      },
      resetCheckoutSession: function () {
        accountDashboardManager.checkoutSession = {
          review: {
            complete: false
          },
          confirmation: {
            complete: false
          }
        };
      },
      cleanCheckoutSession: function () {
        sessionStorage.removeItem('checkoutSession');
      },
      getTimeSlots: function (time) {
        var _params,
          _promise;

        _params = {
          serviceRequiredDate: time ? moment(time).format('YYYY-MM-D') : moment(changeTechInstallService.currentTechInstallAppointment.appointmentDate).format('YYYY-MM-D'),
          accountNumber: util.getCacheVariable('internetSelectedAccountNumber')
        };

        notifier.notify.processing();

        _promise = $http({
          url: uteEndpoint('v1/manageAppointments'),
          method: 'POST',
          data: _params,
          cache: false
        }).error(function (resp) {
          notifier.notify.error();
        }).success(function () {
          notifier.notify.done();
        });

        return _promise;
      },
      submitOrder: function () {
        var deferred = $q.defer();
        var _params = {
          subscriptionID: commonService.internetSubscriberNo,
          accountNumber: commonService.internetAccountNumber
        };

        notifier.notify.processing();

        $http({
          url: uteEndpoint('v1/confirmOrder'),
          method: 'POST',
          data: _params
        }).success(function (resp) {
          console.log('@accountDashboardManager:submitOrder() HTTP:SUCCESS (resp)', resp);
          if (resp.confirmChangeInternetPkg && resp.confirmChangeInternetPkg.error) {
            notifier.notify.error({ errorCode: resp.confirmChangeInternetPkg.error });
            return;
          }

          notifier.notify.done();
          deferred.resolve(resp);
        }).error(function (resp, status) {
        _satellite.setVar("error"," FHSI|ADDRESS NOT FOUND IN SERVER");
       _satellite.track("bfa-fhsi-error");
          console.log('@accountDashboardManager:confirmChangeInternetPackage:HTTP:ERROR (resp, status)', resp, status);

          deferred.reject(resp);
          notifier.notify.error();
        });

        return deferred.promise;
      },
      confirmChangeTechAppointment: function (param) {

        if (!param) return;

        param.accountNumber=util.getCacheVariable('internetSelectedAccountNumber');


        notifier.notify.processing();

        return $http({
          url: uteEndpoint('v1/confirmAppointment'),
          method: 'POST',
          data: param,
          cache: false
        }).error(function () {

          changeTechInstallService.newTechInstallChangeSuccessful = false;
          notifier.notify.error();
        }).success(function (resp) {
          if (!resp.error && resp.orderID)
            changeTechInstallService.newTechInstallChangeSuccessful = true;
          else
            changeTechInstallService.newTechInstallChangeSuccessful = false;

          notifier.notify.done();
        });
      },
      confirmChangeInternetPackage: function (confirmed) {

        if (typeof confirmed === 'boolean')
          this.changeInternetPackageConfirmed = confirmed;
        else
          return this.changeInternetPackageConfirmed;
      },
      reviewChangeInternetPackage: function () {
        var resKey = 'reviewChangeInternetPkg';
        var deferred = $q.defer();
        if (this.currentInternetPackage && this.newInternetPackage) {

          $http({
            url: uteEndpoint('v1/reviewOrder'),
            method: 'POST',
            data: {
              accountNumber: commonService.internetAccountNumber,
              subscriberNo: commonService.internetSubscriberNo,
              hashKey: $rootScope.atg.hashKey.value,
              samKey: $rootScope.userPref.samKey,
              userId: $rootScope.atg.userId.value,
              province: uteLocale.province,
              tierIdIn: this.newInternetPackage.selectedOffer.tierId,
              productIdIn: this.newInternetPackage.selectedOffer.productId,
              offerIdIn: this.newInternetPackage.selectedOffer.offerId,
              tierIdOut: this.currentInternetPackage.selectedOffer.tierId,
              productIdOut: this.currentInternetPackage.selectedOffer.productId,
              offerIdOut: this.currentInternetPackage.selectedOffer.offerId
            },
            cache: false
          }).success(function (data) {
            console.log('reviewChangeInternetPackage --s (data)', data);
            if (data && data[resKey] && data[resKey].error) {

              deferred.reject(data);
            }
            else if (data && data.error) {

              deferred.reject(data);
            }
            else {
              deferred.resolve(data);
            }

          }).error(function (data) {

            console.log('reviewChangeInternetPackage --e (data)', data);
            deferred.reject(data);
          });
          return deferred.promise;
        }

        deferred.reject();
        return deferred.promise;
      },
      __backup_original__reviewChangeInternetPackage: function () {
        if (this.currentInternetPackage && this.newInternetPackage) {
          var endpoint = uteEndpoint('v1/reviewOrder');

          try {
            var params = {
              accountNumber: commonService.internetAccountNumber,
              subscriberNo: commonService.internetSubscriberNo,
              hashKey: $rootScope.atg.hashKey.value,
              samKey: $rootScope.userPref.samKey,
              userId: $rootScope.atg.userId.value,
              province: uteLocale.province,
              tierIdIn: this.newInternetPackage.selectedOffer.tierId,
              productIdIn: this.newInternetPackage.selectedOffer.productId,
              offerIdIn: this.newInternetPackage.selectedOffer.offerId,
              tierIdOut: this.currentInternetPackage.selectedOffer.tierId,
              productIdOut: this.currentInternetPackage.selectedOffer.productId,
              offerIdOut: this.currentInternetPackage.selectedOffer.offerId
            };

            return $http({
              url: endpoint,
              method: 'POST',
              data: params,
              cache: false
            });
          }
          catch (ex) {
            console.log('reviewChangeInternetPackage error: ', ex);
            var deferred = $q.defer();
            deferred.reject();
            return deferred.promise;
          }
        }
        else {
          var deferred = $q.defer();
          deferred.reject();
          return deferred.promise;
        }
      },

      debugGetChangeInternetOffers: function () {
        // about: dummy changeInternetOffers response
        // debug
        return {
          "reviewChangeInternetPkg": {
            "billingAddress": {
              "postalCode": "L4B4V6",
              "province": "ON",
              "city": "RICHMOND HILL",
              "country": "CAN",
              "streetName": "BAYVIEW",
              "streetNumber": "9133",
              "streetType": "AVE",
              "direction": null,
              "unitNumber": "58",
              "pobox": null,
              "unitDesignator": null
            },
            "billingPreference": {
              "paymentType": "On Receipt of Invoice",
              "receiveBill": "Online",
              "sendBill": "ITen@gmail.com"
            },
            "serviceAddress": {
              "postalCode": "L4B4V6",
              "province": "ON",
              "city": "RICHMOND HILL",
              "country": null,
              "streetName": "BAYVIEW",
              "streetNumber": "9133",
              "streetType": null,
              "direction": null,
              "unitNumber": "58",
              "pobox": null,
              "unitDesignator": null
            },
            "contactDetails": {
              "phoneNumber": "4161111111",
              "email": null
            },
            "packageAdded": {
              "tierId": "cat10007",
              "name": "Tier 1",
              "qty": "1",
              "speed": {
                "download": 15.0,
                "downloadUnit": "Mbps",
                "upload": 1.0,
                "uploadUnit": "Mbps"
              },
              "products": {
                "offers": {
                  "offerId": null,
                  "name": null,
                  "offerPrice": {
                    "price": 50.0
                  },
                  "rentalModem": false,
                  "additionalPrice": null,
                  "overagePrice": 0.0,
                  "overageUnit": null,
                  "content": null,
                  "usageAllowance": "200 GB",
                  "details": null
                },
                "id": null
              },
            },
            "monthlyFees": null,
            "packageRemoved": {
              "tierId": "cat10007",
              "name": "Tier 1",
              "qty": "1",
              "speed": {
                "download": 15.0,
                "downloadUnit": "Mbps",
                "upload": 1.0,
                "uploadUnit": "Mbps"
              },
              "products": {
                "offers": {
                  "offerId": "sku10004",
                  "name": "Fido Internet (FD10)",
                  "offerPrice": {
                    "price": 53.99,
                    "priceFrequency": "monthly"
                  },
                  "rentalModem": true,
                  "additionalPrice": {
                    "price": 0.0,
                    "priceFrequency": null
                  },
                  "overagePrice": 100.0,
                  "overageUnit": "MB",
                  "content": {
                    "offerDetails": null
                  },
                  "usageAllowance": "200 GB ",
                  "details": null
                },
                "id": "prod10005"
              }
            },
            "agreement": {
              "date": "2015-08-05T11:48:36.506",
              "place": "RICHMOND HILL, ON"
            },
            "error": ""
          }
        };
        // end debug
      }
    };

    return accountDashboardManager;
  }]);
})();
